export default __webpack_public_path__ + "static/media/damascus.f0fab330.jpg";